/* Featured stores carousel – shows stores from the visitor's city (GeoIP) with a city dropdown */
(function () {
  var CACHE_KEY = 'sp-stores-feed-v2', CACHE_MS = 30 * 60 * 1000;   // same cache as the store locator
  var CITY_KEY = 'sp-city-v2', GEO_KEY = 'sp-geo-v2';
  var NEAR_KM = 150;  // GeoIP is approximate (often the ISP's city), so allow a wide radius
  // free GeoIP services tried in order after the one set in the theme editor (all CORS-enabled, no key)
  var GEO_FALLBACKS = ['https://get.geojs.io/v1/ip/geo.json', 'https://ipwho.is/', 'https://ipapi.co/json/'];
  function log(m) { if (window.console) console.info('[Featured stores] ' + m); }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z]/g, ''); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function dist(a, b, c, d) {
    var R = 6371, r = Math.PI / 180, x = (c - a) * r, y = (d - b) * r;
    var h = Math.sin(x / 2) * Math.sin(x / 2) + Math.cos(a * r) * Math.cos(c * r) * Math.sin(y / 2) * Math.sin(y / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function loadStores(feed) {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < CACHE_MS && c.f === feed) return Promise.resolve(c.s);
    } catch (e) {}
    return fetch(feed + '&page=1', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
      var seen = {}, s = (d.stores || []).filter(function (x) { if (seen[x.u]) return false; seen[x.u] = 1; return true; });
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), f: feed, s: s })); } catch (e) {}
      return s;
    });
  }

  /* GeoIP: tries several services, caches a GOOD answer for 1 day (failures are not cached) */
  function fetchJSON(url) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 3500);
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
      .then(function (r) { clearTimeout(timer); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function parseGeo(j) {
    if (!j || j.error || j.success === false) return null;
    var d = {
      city: j.city || j.city_name || '',
      cc: String(j.country_code || j.countryCode || '').toUpperCase(),
      lat: parseFloat(j.latitude != null ? j.latitude : j.lat),
      lng: parseFloat(j.longitude != null ? j.longitude : (j.lon != null ? j.lon : j.lng))
    };
    return (d.city || !isNaN(d.lat)) ? d : null;
  }
  function geoip(url) {
    try {
      var g = JSON.parse(store(GEO_KEY) || 'null');
      if (g && g.d && Date.now() - g.t < 864e5) return Promise.resolve(g.d);
    } catch (e) {}
    var list = [url].concat(GEO_FALLBACKS).filter(function (u, i, a) { return u && a.indexOf(u) === i; });
    function tryNext(i) {
      if (i >= list.length) return Promise.resolve(null);
      return fetchJSON(list[i]).then(parseGeo).catch(function (e) { log('GeoIP failed: ' + list[i] + ' (' + e.message + ')'); return null; })
        .then(function (d) {
          if (!d) return tryNext(i + 1);
          log('GeoIP ' + list[i] + ' → ' + (d.city || '?') + ', ' + d.cc + ' (' + d.lat + ', ' + d.lng + ')');
          store(GEO_KEY, JSON.stringify({ t: Date.now(), d: d }));
          return d;
        });
    }
    return tryNext(0);
  }

  function remember(v) { store(CITY_KEY, JSON.stringify({ v: v, t: Date.now() })); }
  function recall() {
    try { var o = JSON.parse(store(CITY_KEY) || 'null'); if (o && Date.now() - o.t < 7 * 864e5) return o.v; } catch (e) {}
    return null;
  }

  function init(root) {
    if (root.__spFeat) return; root.__spFeat = true;
    var track = root.querySelector('[data-sp-track]');
    var select = root.querySelector('[data-sp-city-select]');
    var wrap = root.querySelector('[data-sp-city-wrap]');
    var title = root.querySelector('[data-sp-feat-title]');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 10;
    var picked = (root.getAttribute('data-picked') || '').split('|').filter(Boolean);
    var heading = root.getAttribute('data-heading') || 'Featured Stores';
    var cityHeading = root.getAttribute('data-city-heading') || 'Stores in [city]';
    var viewLabel = root.getAttribute('data-view-label') || 'View Store';
    var icons = {};
    var tpl = root.querySelector('[data-sp-icons]');
    if (tpl) [].forEach.call(tpl.content.querySelectorAll('[data-i]'), function (n) { icons[n.getAttribute('data-i')] = n.innerHTML; });
    var original = track.innerHTML, stores = [], cities = [];

    // carousel arrows
    function step() { var c = track.querySelector('.sp-scard'); return c ? c.getBoundingClientRect().width + 20 : 300; }
    root.querySelector('[data-sp-prev]').addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    root.querySelector('[data-sp-next]').addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    function card(s) {
      var tel = String(s.p || '').replace(/[^\d+]/g, '');
      var img = s.i2 || s.i;
      return '<div class="sp-scard sp-scard--slide">' +
        '<a class="sp-scard__img" href="' + esc(s.u) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(s.n) + '" loading="lazy">' : '') +
        (s.r ? '<span class="sp-scard__rating">' + (icons.star || '★') + esc(s.r) + '</span>' : '') + '</a>' +
        '<div class="sp-scard__body"><h3 class="sp-scard__name"><a href="' + esc(s.u) + '">' + esc(s.n) + '</a></h3>' +
        '<p class="sp-scard__loc">' + (icons.pin || '') + esc([s.a, s.c].filter(Boolean).join(', ')) + '</p>' +
        '<div class="sp-scard__foot">' + (s.p ? '<a class="sp-scard__phone" href="tel:' + esc(tel) + '">' + (icons.phone || '') + esc(s.p) + '</a>' : '<span></span>') +
        '<a class="sp-btn sp-btn--outline sp-btn--xs" href="' + esc(s.u) + '">' + esc(viewLabel) + '</a></div></div></div>';
    }

    function show(city) {
      select.value = city || '';
      if (!city) { track.innerHTML = original; title.textContent = heading; track.scrollLeft = 0; return; }
      var list = stores.filter(function (s) { return s.c === city; });
      // featured stores in this city first, then the rest (highest rated first)
      list.sort(function (a, b) {
        var pa = picked.indexOf(a.u) > -1 ? 0 : 1, pb = picked.indexOf(b.u) > -1 ? 0 : 1;
        return pa - pb || (b.r || 0) - (a.r || 0) || a.n.localeCompare(b.n);
      });
      if (!list.length) { show(''); return; }
      track.innerHTML = list.slice(0, limit).map(card).join('');
      title.textContent = cityHeading.replace('[city]', city);
      track.scrollLeft = 0;
    }

    function cityFromGeo(g) {
      if (!g) return '';
      if (g.cc && g.cc !== 'PK') return '';
      var byName = cities.filter(function (c) { return norm(c) === norm(g.city); })[0];
      if (byName) return byName;
      if (isNaN(g.lat) || isNaN(g.lng)) return '';
      var best = null, bd = 1e9;
      stores.forEach(function (s) {
        if (s.lat == null) return;
        var d = dist(g.lat, g.lng, +s.lat, +s.lng);
        if (d < bd) { bd = d; best = s; }
      });
      return best && bd <= NEAR_KM ? best.c : '';
    }

    loadStores(root.getAttribute('data-feed')).then(function (s) {
      stores = s;
      var count = {};
      stores.forEach(function (x) { if (x.c) count[x.c] = (count[x.c] || 0) + 1; });
      cities = Object.keys(count).sort(function (a, b) { return a.localeCompare(b); });
      select.insertAdjacentHTML('beforeend', cities.map(function (c) {
        return '<option value="' + esc(c) + '">' + esc(c) + ' (' + count[c] + ')</option>';
      }).join(''));
      wrap.hidden = false;
      if (navigator.geolocation) select.options[0].insertAdjacentHTML('afterend', '<option value="__loc">' + esc(root.getAttribute('data-loc-label') || 'Use my location') + '</option>');
      select.value = '';
      select.addEventListener('change', function () {
        if (select.value === '__loc') {
          navigator.geolocation.getCurrentPosition(function (p) {
            var c = cityFromGeo({ cc: 'PK', lat: p.coords.latitude, lng: p.coords.longitude });
            if (c) { remember(c); show(c); } else show('');
          }, function () { show(''); }, { timeout: 10000, maximumAge: 600000 });
          return;
        }
        remember(select.value || '-'); show(select.value);
      });

      var saved = recall();
      if (saved === '-') { log('visitor chose All cities earlier'); return; }
      if (saved && count[saved]) { log('remembered city: ' + saved); show(saved); return; }
      geoip(root.getAttribute('data-geo')).then(function (g) {
        var c = cityFromGeo(g);
        log(c ? 'showing city: ' + c : 'no matching city – showing featured stores');
        if (c) show(c);
      });
    }).catch(function () { /* keep the server-rendered featured stores */ });
  }

  function boot() { document.querySelectorAll('[data-sp-featured]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
